import { MedicalsSubData } from "../../Model/index";

export class MedicalData {
    REPORT_NO : number;
    REPORT_DATE : string;
    DOCTOR_CODE : string;
    HospitalNo : string;
    Instructions: string;
    doctorName: string;
    department: string;
    MedicalsSubData: MedicalsSubData[];
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/medicalreport/medicaldata.ts